var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-btn',{attrs:{"size":_vm.size,"variant":"secondary","block":_vm.block,"loading":_vm.loading}},[_vm._t("default",function(){return [_vm._v(" message")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }